import '../server/require-hook'

export {
  getDefinedNamedExports,
  hasCustomGetInitialProps,
  isPageStatic,
} from './utils'
export { exportPages } from '../export/worker'
